import { Identity, RevenueIdentifyingProps } from '../types';
import { formatLocalStorageKey } from '../utils';
import { Userpilot } from 'userpilot';

const getNewZuoraExperience = (): boolean => {
  try {
    let newZuoraExperience = false;
    const userPrefString = localStorage.getItem(
      formatLocalStorageKey('ZRedirectUserPreference'),
    );
    if (userPrefString) {
      const userPref = JSON.parse(userPrefString);
      newZuoraExperience = !!userPref.reinvented;
    }
    return newZuoraExperience;
  } catch (e) {
    return false;
  }
};

export const initUserpilotVariables = (
  identity: Identity & RevenueIdentifyingProps,
) => {
  try {
    const userId = identity.userId || identity.coreUserId;
    Userpilot.identify(userId, {
      name: identity.username,
      email: identity.workEmail,
      role: identity.platformRole,
      global_tenant_status: identity.globalTenantStatus,
      global_tenant_trial_end_date: identity.globalTenantTrialEndDate,
      locale_code: identity.language,
      new_zuora_experience: getNewZuoraExperience(),
      company: {
        id: identity?.tenantMetadata?.companyName,
        name: identity?.tenantMetadata?.companyName,
      },
      ...(identity.tenantMetadata || {}),
      // Note: userpilot GUI cannot introspect Objects, such as `identity`. Primitives are spread below, but nested objects need to be spread as needed.
      ...Object.entries(identity)
        .filter(([, value]) => value !== Object(value))
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {}),
    });
  } catch (e) {
    console.warn('Unable to initialize userpilot', e);
  }
};

export const userPilotReload = () => {
  try {
    Userpilot.reload();
  } catch (e) {
    console.warn('Unable to reload UserPilot');
  }
};
